export default "__VITE_ASSET__CziYBrao__"